/* eslint-disable quote-props */
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { CircleAlertIcon, CircleCheckIcon } from "../../../../../../components/Icons";
import ChevronDownIcon from "../../../../../../components/Icons/ChevronDownVisit";

interface PrescriptionAccordionProps {
  title: string;
  count: number;
  variant: "actionRequired" | "activePrescriptions";
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

const PrescriptionAccordion = ({
  title,
  count,
  variant,
  children,
  defaultExpanded = true,
}: PrescriptionAccordionProps) => {
  const theme = useTheme();

  const VARIANT_CONFIG = {
    actionRequired: {
      backgroundColor: theme.palette.red.lighter,
      color: theme.palette.red.dark,
      icon: CircleAlertIcon,
    },
    activePrescriptions: {
      backgroundColor: theme.palette.green.lighter,
      color: theme.palette.green.dark,
      icon: CircleCheckIcon,
    },
  };

  const config = VARIANT_CONFIG[variant];
  const IconComponent = config.icon;

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        borderRadius: "8px",
        boxShadow: "none",
        padding: { xs: "0 16px 0 16px", md: "0 44px 0 24px" },
        border: (theme) => `1px solid ${theme.palette.neutral.main}`,
        "&.Mui-expanded": {
          margin: 0,
        },
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        sx={{
          padding: 0,
        }}
        expandIcon={<ChevronDownIcon width={20} height={20} color={theme.palette.neutral.dark} />}
      >
        <Box
          className="flex items-center justify-center rounded-full"
          sx={{
            width: 24,
            height: 24,
            backgroundColor: config.backgroundColor,
            marginRight: "8px",
          }}
        >
          <IconComponent width={14} height={14} color={config.color} />
        </Box>
        <Typography fontWeight={600}>{title}</Typography>
        <Box
          className="flex items-center justify-center rounded-full"
          sx={{
            width: 22,
            height: 22,
            backgroundColor: config.backgroundColor,
            marginLeft: "8px",
          }}
        >
          <Typography color={config.color} fontWeight={600} fontSize={12}>
            {count}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails className="flex flex-col gap-4" sx={{ padding: "8px 0px 24px 0px" }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default PrescriptionAccordion;
